import React, { useState, lazy, Suspense } from "react";
import { AdminLogin } from "./components/AdminLogin";
import { AdminSidebar } from "./components/AdminSidebar";
import { useAdminData } from "./hooks/useAdmin";

// Lazy load các tab để tăng tốc độ tải trang ban đầu
const DashboardTab = lazy(() =>
  import("./components/DashboardTab").then((m) => ({
    default: m.DashboardTab,
  })),
);
const CategoryTab = lazy(() =>
  import("./components/category/CategoryTab").then((m) => ({
    default: m.CategoryTab,
  })),
);
const ProductTab = lazy(() =>
  import("./components/products/ProductTab").then((m) => ({
    default: m.ProductTab,
  })),
);
const ContactTab = lazy(() =>
  import("./components/ContactTab").then((m) => ({ default: m.ContactTab })),
);

export default function AdminPage() {
  const [token, setToken] = useState<string | null>(
    localStorage.getItem("admin_token"),
  );
  const [activeTab, setActiveTab] = useState("dashboard");

  const {
    categories,
    products,
    contacts,
    createCategory,
    updateCategory,
    deleteCategory,
    createProduct,
    updateProduct,
    deleteProduct,
    updateContactStatus,
    deleteContact,
  } = useAdminData(!!token);

  if (!token) {
    return <AdminLogin onLoginSuccess={(t) => setToken(t)} />;
  }

  const stats = {
    productsCount: products.length,
    categoriesCount: categories.length,
    contactsCount: contacts.length,
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <AdminSidebar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        onLogout={() => {
          localStorage.removeItem("admin_token");
          setToken(null);
        }}
      />
      <main className="flex-1 p-8 overflow-y-auto">
        <header className="mb-8 flex justify-between items-center">
          <h2 className="text-2xl font-bold text-gray-800 capitalize">
            {activeTab === "dashboard" && "Tổng quan hệ thống"}
            {activeTab === "categories" && "Quản lý danh mục gạo"}
            {activeTab === "products" && "Quản lý sản phẩm gạo xuất khẩu"}
            {activeTab === "contacts" && "Quản lý yêu cầu liên hệ"}
          </h2>
          <span className="text-sm font-medium text-gray-600 bg-white px-4 py-2 rounded-xl shadow-sm border border-gray-100">
            Xin chào, Admin
          </span>
        </header>

        <Suspense
          fallback={
            <div className="py-12 text-center text-gray-400">
              Đang tải dữ liệu...
            </div>
          }
        >
          {activeTab === "dashboard" && <DashboardTab stats={stats} />}
          {activeTab === "categories" && (
            <CategoryTab
              categories={categories}
              createMutation={createCategory}
              updateMutation={updateCategory}
              deleteMutation={deleteCategory}
            />
          )}
          {activeTab === "products" && (
            <ProductTab
              products={products}
              categories={categories}
              createMutation={createProduct}
              updateMutation={updateProduct}
              deleteMutation={deleteProduct}
            />
          )}
          {activeTab === "contacts" && (
            <ContactTab
              contacts={contacts}
              statusMutation={updateContactStatus}
              deleteMutation={deleteContact}
            />
          )}
        </Suspense>
      </main>
    </div>
  );
}
